import type { ValueOf } from './util/typeUtils';

export const BUILDING_DESCRIPTION_PROPERTY_TYPES = {
    DOPPELHAUSHAELFTE: 'DOPPELHAUSHAELFTE',
    DREIFAMILIENHAUS: 'DREIFAMILIENHAUS',
    EIGENTUMSWOHNUNG: 'EIGENTUMSWOHNUNG',
    EINFAMILIENHAUS: 'EINFAMILIENHAUS',
    EINFAMILIENHAUS_MIT_EINLIEGERWOHNUNG: 'EINFAMILIENHAUS_MIT_EINLIEGERWOHNUNG',
    MEHRFAMILIENHAUS: 'MEHRFAMILIENHAUS',
    REIHENENDHAUS: 'REIHENENDHAUS',
    REIHENMITTELHAUS: 'REIHENMITTELHAUS',
    WOHN_UND_GESCHAEFTSHAUS: 'WOHN_UND_GESCHAEFTSHAUS',
    ZWEIFAMILIENHAUS: 'ZWEIFAMILIENHAUS',
} as const;

export const BUILDING_DESCRIPTION_PROPERTY_TYPES_IN_DISPLAY_ORDER = [
    BUILDING_DESCRIPTION_PROPERTY_TYPES.EIGENTUMSWOHNUNG,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.EINFAMILIENHAUS,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.EINFAMILIENHAUS_MIT_EINLIEGERWOHNUNG,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.REIHENENDHAUS,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.REIHENMITTELHAUS,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.DOPPELHAUSHAELFTE,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.ZWEIFAMILIENHAUS,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.DREIFAMILIENHAUS,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.MEHRFAMILIENHAUS,
    BUILDING_DESCRIPTION_PROPERTY_TYPES.WOHN_UND_GESCHAEFTSHAUS,
] as const;

export const BUILDING_DESCRIPTION_PROPERTY_TYPES_WITH_UNIT_COUNT: ReadonlySet<BUILDING_DESCRIPTION_PROPERTY_TYPE> =
    new Set([
        BUILDING_DESCRIPTION_PROPERTY_TYPES.EIGENTUMSWOHNUNG,
        BUILDING_DESCRIPTION_PROPERTY_TYPES.MEHRFAMILIENHAUS,
        BUILDING_DESCRIPTION_PROPERTY_TYPES.WOHN_UND_GESCHAEFTSHAUS,
    ]);

export const BUILDING_CONSTRUCTION_TYPES = {
    FACHWERKHAUS: 'FACHWERKHAUS',
    FERTIGHAUS_HOLZ: 'FERTIGHAUS_HOLZ',
    FERTIGHAUS_MASSIV: 'FERTIGHAUS_MASSIV',
    HOLZSTAENDERBAUWEISE: 'HOLZSTAENDERBAUWEISE',
    LEHMBAUWEISE: 'LEHMBAUWEISE',
    MASSIVBAUWEISE: 'MASSIVBAUWEISE',
    PLATTENBAUWEISE: 'PLATTENBAUWEISE',
} as const;

export const BUILDING_CONSTRUCTION_TYPES_IN_DISPLAY_ORDER = [
    BUILDING_CONSTRUCTION_TYPES.MASSIVBAUWEISE,
    BUILDING_CONSTRUCTION_TYPES.FERTIGHAUS_MASSIV,
    BUILDING_CONSTRUCTION_TYPES.FERTIGHAUS_HOLZ,
    BUILDING_CONSTRUCTION_TYPES.FACHWERKHAUS,
    BUILDING_CONSTRUCTION_TYPES.HOLZSTAENDERBAUWEISE,
    BUILDING_CONSTRUCTION_TYPES.LEHMBAUWEISE,
    BUILDING_CONSTRUCTION_TYPES.PLATTENBAUWEISE,
] as const;

export const ROOF_DEVELOPMENT_TYPES = {
    NICHT_AUSBAUFAEHIG: 'NICHT_AUSBAUFAEHIG',
    NICHT_AUSGEBAUT: 'NICHT_AUSGEBAUT',
    TEILWEISE_AUSGEBAUT: 'TEILWEISE_AUSGEBAUT',
    VOLL_AUSGEBAUT: 'VOLL_AUSGEBAUT',
} as const;

export const ROOF_SHAPES = {
    FLACHDACH: 'FLACHDACH',
    KRUEPPELDACH: 'KRUEPPELDACH',
    KRUEPPELWALMDACH: 'KRUEPPELWALMDACH',
    MANSARDDACH: 'MANSARDDACH',
    PULTDACH: 'PULTDACH',
    SATTELDACH: 'SATTELDACH',
    WALMDACH: 'WALMDACH',
} as const;

export const ROOF_COVERING_TYPES = {
    BETONDACHSTEINE: 'BETONDACHSTEINE',
    ETERNIT: 'ETERNIT',
    GRUENDACH: 'GRUENDACH',
    METALLBEDACHUNG: 'METALLBEDACHUNG',
    NATURSCHIEFERBEDACHUNG: 'NATURSCHIEFERBEDACHUNG',
    PAPPDACH: 'PAPPDACH',
    REETDACH: 'REETDACH',
    ZIEGELDECKUNG: 'ZIEGELDECKUNG',
} as const;

export const WINDOW_TYPES = {
    HOLZFENSTER: 'HOLZFENSTER',
    HOLZFENSTER_ISOLIERGLAS: 'HOLZFENSTER_ISOLIERGLAS',
    KUNSTSTOFFFENSTER: 'KUNSTSTOFFFENSTER',
    KUNSTSTOFFFENSTER_ISOLIERGLAS: 'KUNSTSTOFFFENSTER_ISOLIERGLAS',
    LEICHTMETALLFENSTER: 'LEICHTMETALLFENSTER',
    LEICHTMETALLFENSTER_ISOLIERGLAS: 'LEICHTMETALLFENSTER_ISOLIERGLAS',
} as const;

export const BASEMENT_TYPES = {
    OHNE_KELLER: 'OHNE_KELLER',
    TEILKELLER_BETON: 'TEILKELLER_BETON',
    TEILKELLER_GEMAUERT: 'TEILKELLER_GEMAUERT',
    VOLLKELLER_BETON: 'VOLLKELLER_BETON',
    VOLLKELLER_GEMAUERT: 'VOLLKELLER_GEMAUERT',
} as const;

export const BASEMENT_DEVELOPMENT_TYPES = {
    NICHT_AUSGEBAUT: 'NICHT_AUSGEBAUT',
    TEILWEISE_AUSGEBAUT: 'TEILWEISE_AUSGEBAUT',
    VOLL_AUSGEBAUT: 'VOLL_AUSGEBAUT',
} as const;

export const HEATING_TYPES = {
    ANDERE: 'ANDERE',
    EINZELOEFEN: 'EINZELOEFEN',
    FUSSBODENHEIZUNG: 'FUSSBODENHEIZUNG',
    HEIZKOERPER: 'HEIZKOERPER',
} as const;

export const ENERGY_SOURCES = {
    ANDERE: 'ANDERE',
    ELEKTRO: 'ELEKTRO',
    ERDWAERME: 'ERDWAERME',
    FERNWAERME: 'FERNWAERME',
    GAS: 'GAS',
    HOLZ_KOHLE: 'HOLZ_KOHLE',
    OELHEIZUNG: 'OELHEIZUNG',
    PELLETS: 'PELLETS',
    PHOTOVOLTAIKANLAGE: 'PHOTOVOLTAIKANLAGE',
    SOLARTHERMIE: 'SOLARTHERMIE',
    WAERMEPUMPE: 'WAERMEPUMPE',
} as const;

export const HOT_WATER_SUPPLY_TYPES = {
    DURCHLAUFERHITZER: 'DURCHLAUFERHITZER',
    ELEKTRO_KLEINSPEICHER: 'ELEKTRO_KLEINSPEICHER',
    SOLARANLAGE: 'SOLARANLAGE',
    WARMWASSER_WAERMEPUMPE: 'WARMWASSER_WAERMEPUMPE',
    WARMWASSERBOILER: 'WARMWASSERBOILER',
    ZENTRALVERSORGUNG: 'ZENTRALVERSORGUNG',
} as const;

export const ENERGY_EFFICIENCY_CLASSES = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    E: 'E',
    F: 'F',
    G: 'G',
    H: 'H',
} as const;

export const SANITARY_FEATURES = {
    BADEWANNE: 'BADEWANNE',
    BIDET: 'BIDET',
    DUSCHE: 'DUSCHE',
    FLIESENBODEN: 'FLIESENBODEN',
    GAESTETOILETTE: 'GAESTETOILETTE',
    GEFLIESTE_WAENDE: 'GEFLIESTE_WAENDE',
} as const;

export const SANITARY_FEATURES_IN_DISPLAY_ORDER = [
    SANITARY_FEATURES.GEFLIESTE_WAENDE,
    SANITARY_FEATURES.BADEWANNE,
    SANITARY_FEATURES.DUSCHE,
    SANITARY_FEATURES.GAESTETOILETTE,
    SANITARY_FEATURES.FLIESENBODEN,
    SANITARY_FEATURES.BIDET,
] as const;

export const PARKING_TYPES = {
    BETON_FERTIG_GARAGE: 'BETON_FERTIG_GARAGE',
    CARPORT: 'CARPORT',
    DOPPELGARAGE_MASSIV_GEMAUERT: 'DOPPELGARAGE_MASSIV_GEMAUERT',
    EINZELGARAGE_MASSIV_GEMAUERT: 'EINZELGARAGE_MASSIV_GEMAUERT',
    STELLPLATZ: 'STELLPLATZ',
    TIEFGARAGENSTELLPLATZ: 'TIEFGARAGENSTELLPLATZ',
} as const;

export const RENOVATION_TYPES = {
    ANDERE: 'ANDERE',
    BAEDER_UND_WCS: 'BAEDER_UND_WCS',
    BODENBELAEGE_WANDBEKLEIDUNG_TREPPENHAUS: 'BODENBELAEGE_WANDBEKLEIDUNG_TREPPENHAUS',
    DACH: 'DACH',
    FENSTER: 'FENSTER',
    HEIZUNG: 'HEIZUNG',
    RAUMAUFTEILUNG: 'RAUMAUFTEILUNG',
    SOLAR_PHOTOVOLTAIK: 'SOLAR_PHOTOVOLTAIK',
    STROM_WASSER_HEIZUNGSLEITUNG: 'STROM_WASSER_HEIZUNGSLEITUNG',
    WAERMEDAEMMUNG_FASSADE: 'WAERMEDAEMMUNG_FASSADE',
} as const;

export const BUILDING_DESCRIPTION_ADDRESS_AND_TYPE_FIELDS = [
    'baujahr',
    'bauweise',
    'denkmalschutz',
    'etage',
    'fremdgenutzteWohnflaeche',
    'geschaetzterWert',
    'grundstuecksgroesse',
    'objektart',
    'pacht',
    'wohneinheitenAnzahl',
    'wohnflaeche',
] as const;

export const BUILDING_DESCRIPTION_ADDRESS_FIELDS = ['hausnummer', 'ort', 'plz', 'strasse'] as const;

export const BUILDING_DESCRIPTION_ROOF_BASEMENT_WINDOW_FIELDS = [
    'dachausbau',
    'dacheindeckung',
    'dachform',
    'kellerausbau',
    'kellerart',
] as const;

export const BUILDING_DESCRIPTION_HEATING_HOT_WATER_FIELDS = [
    'energieeffizienz',
    'energietraegerAndere',
    'heizungsartAndere',
    'warmwasserversorgung',
] as const;

export const BUILDING_DESCRIPTION_PARKING_SPACE_FIELDS = ['anzahl', 'art'] as const;

export const BUILDING_DESCRIPTION_RENOVATION_SECTION_FIELDS = [
    'alsEigentuemerImGrundbuchEingetragen',
    'besonderheitenImGrundbuch',
    'teilungserklaerungVorhanden',
] as const;

export const BUILDING_DESCRIPTION_RENOVATION_FIELDS = ['art', 'bezeichnung', 'ergaenzungen', 'jahr'] as const;

export type BUILDING_DESCRIPTION_PROPERTY_TYPE = ValueOf<typeof BUILDING_DESCRIPTION_PROPERTY_TYPES>;
export type BUILDING_CONSTRUCTION_TYPE = ValueOf<typeof BUILDING_CONSTRUCTION_TYPES>;
export type ROOF_DEVELOPMENT_TYPE = ValueOf<typeof ROOF_DEVELOPMENT_TYPES>;
export type ROOF_SHAPE = ValueOf<typeof ROOF_SHAPES>;
export type ROOF_COVERING_TYPE = ValueOf<typeof ROOF_COVERING_TYPES>;
export type WINDOW_TYPE = ValueOf<typeof WINDOW_TYPES>;
export type BASEMENT_TYPE = ValueOf<typeof BASEMENT_TYPES>;
export type BASEMENT_DEVELOPMENT_TYPE = ValueOf<typeof BASEMENT_DEVELOPMENT_TYPES>;
export type HEATING_TYPE = ValueOf<typeof HEATING_TYPES>;
export type ENERGY_SOURCE = ValueOf<typeof ENERGY_SOURCES>;
export type HOT_WATER_SUPPLY_TYPE = ValueOf<typeof HOT_WATER_SUPPLY_TYPES>;
export type ENERGY_EFFICIENCY_CLASS = ValueOf<typeof ENERGY_EFFICIENCY_CLASSES>;
export type SANITARY_FEATURE = ValueOf<typeof SANITARY_FEATURES>;
export type PARKING_TYPE = ValueOf<typeof PARKING_TYPES>;
export type RENOVATION_TYPE = ValueOf<typeof RENOVATION_TYPES>;
